export function filterIteroImages(images) {
  if (!images?.length) return images
  return images.filter(image => image.type_key === 'itero')
}
